// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { rollux as _rollux } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the rollux chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 570
 * Chain Name: Rollux Mainnet
 * Default Block Explorer: https://explorer.rollux.com
 * Default RPC URL: https://rpc.rollux.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { rollux } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: rollux,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const rollux = createCommon({
	..._rollux,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
